import { LineageNode } from "./FileLineageTree.types";
import { LineageNodeItem } from "./LineageNodeItem";

export function ChildLineageNode({ node }: { node: LineageNode }) {
    return (
        <>
            <LineageNodeItem node={node} isLast={false} level={1} frontDash />
            {node.nodes && node.nodes.length > 0 && (
                <ul className="flex flex-col gap-6">
                    {node.nodes?.map((childNode) => (
                        <LineageNodeItem
                            key={childNode.id}
                            node={childNode}
                            level={2}
                            isLast
                        />
                    ))}
                </ul>
            )}
        </>
    );
}
